import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import RatingStars from 'components/Rating/RatingStars/index';
import PrivateMessageButton from 'components/Messenger/content/PrivateMessageButton';
import { t } from 'utils/translates';

import ManageBlock from '../../../EarnMoney/TaskViewAsExecutor/ManageBlock';
import UserBlackListControl from './UserBlackListControl';

// eslint-disable-next-line react/prefer-stateless-function
class RightSidebarUserProfile extends Component {
  render() {
    return (
      <div className="page-sidebar-sticky">
        <div className="page-sidebar-sticky-wrp">
          <div
            className="panel-group panel-group-side"
            id="panelGroupFilter"
            role="tablist"
            aria-multiselectable="true"
          >
            <div className="panel panel-default border-b text-center">
              <div className="panel-body">
                <img
                  alt=""
                  className="avatar avatar-responsive avatar_bordered"
                  src={this.props.userInfo.avatarPath}
                />
                <div
                  className="label label-light label-success label_block text-overflow m-t-10"
                  data-toggle="tooltip"
                  data-container="body"
                  data-placement="top"
                  title={`${t('Рейтинг')}: ${
                    this.props.userInfo.rating.ratingStatusPoints
                  }/${this.props.userInfo.rating.ratingStatusPointsTo} (${
                    this.props.userInfo.rating.ratingStatusTitle
                  })`}
                >
                  <RatingStars rating={this.props.userInfo.rating.rating} />{' '}
                  {this.props.userInfo.rating.ratingStatusTitle}
                </div>
              </div>
            </div>
            <NavLink
              to={`/users/profile/${this.props.userInfo.id}/comments`}
              activeClassName="active"
              className="list-group-item"
            >
              <span className="badge">
                {this.props.userInfo.countsStat.commentsIn.total}
              </span>
              <span className="list-group-item-val text-overflow">
                {t('Отзывы о пользователе')}
              </span>
            </NavLink>
            <NavLink
              to={`/users/profile/${this.props.userInfo.id}/tasks`}
              activeClassName="active"
              className="list-group-item"
            >
              <span className="badge">
                {this.props.userInfo.countsStat.tasks.count}
              </span>
              <span className="list-group-item-val text-overflow">
                {t('Задания пользователя')}
              </span>
            </NavLink>
            <NavLink
              to={`/users/profile/${this.props.userInfo.id}/comments-from-user`}
              activeClassName="active"
              className="list-group-item"
            >
              <span className="badge">
                {this.props.userInfo.countsStat.commentsOut.total}
              </span>
              <span className="list-group-item-val text-overflow">
                {t('Оценки, комментарии')}
              </span>
            </NavLink>
          </div>
          <UserBlackListControl userInfo={this.props.userInfo} />
          <ManageBlock userModel={this.props.userInfo} />
          <PrivateMessageButton userId={this.props.userInfo.id} />
        </div>
      </div>
    );
  }
}

RightSidebarUserProfile.propTypes = {
  userInfo: PropTypes.shape({
    id: PropTypes.number.isRequired,
    avatarPath: PropTypes.string.isRequired,
    username: PropTypes.string.isRequired,
    rating: PropTypes.shape({
      rating: PropTypes.string.isRequired,
      ratingStatusPoints: PropTypes.number.isRequired,
      ratingStatusPointsTo: PropTypes.number.isRequired,
      ratingStatusTitle: PropTypes.string.isRequired
    }).isRequired,
    countsStat: PropTypes.shape({
      tasks: PropTypes.shape({
        count: PropTypes.number.isRequired
      }),
      commentsIn: PropTypes.shape({
        total: PropTypes.number.isRequired
      }).isRequired,
      commentsOut: PropTypes.shape({
        total: PropTypes.number.isRequired
      }).isRequired
    })
  }).isRequired
};

export default RightSidebarUserProfile;



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Users/UserProfile/RightSidebarUserProfile/RightSidebarUserProfile.js